import React, { useState, useEffect, useCallback } from 'react';
import { useScore } from '../../context/ScoreProvider';
import '../../styles/QuizScreen.css';

export default function QuizScreen({ 
  question,
  image,
  images,
  columnDirection,
  options,
  feedback,
  onCheckStateChange,
  screenId,
  screenScore
}) {
  const { submitAnswer } = useScore();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleSelect = (option, index) => {
    if (isChecked) return;
    setSelectedOption({ ...option, index });
  };

  const handleCheck = useCallback(() => {
    if (!selectedOption) return;

    setIsChecked(true);
    if (screenScore != null) {
      submitAnswer(screenId, screenScore, selectedOption.correct);
    }
    onCheckStateChange?.({
      checked: true,
      correct: selectedOption.correct,
    });
  }, [onCheckStateChange, screenId, screenScore, selectedOption, submitAnswer]);

  useEffect(() => {
    onCheckStateChange?.({
      checked: isChecked,
      canCheck: !!selectedOption,
      onCheck: handleCheck,
    });
  }, [selectedOption, isChecked, handleCheck, onCheckStateChange]);

  const hasLinkedImages = images && Array.isArray(images) && images.length > 0;

  const getImageState = (imageIndex) => {
    if (!isChecked || !selectedOption) return 'default';

    if (images[imageIndex]?.linkedTo === selectedOption.index) {
      return selectedOption.correct ? 'correct' : 'incorrect';
    }

    return 'default';
  };

  const showFeedback =
    isChecked &&
    selectedOption &&
    ((selectedOption.correct && feedback?.correct) ||
     (!selectedOption.correct && feedback?.incorrect));

  const feedbackClass = selectedOption?.correct
    ? 'quiz-feedback-correct'
    : 'quiz-feedback-incorrect';

  const feedbackContent = selectedOption?.correct
    ? feedback?.correct
    : feedback?.incorrect;

  return (
    <div className="quiz-screen">
      <div className={`quiz-card ${showFeedback ? 'blurred' : ''}`}>

        {question && (
          <div
            className={`
              quiz-question 
              font-${question?.fontSize ?? "md"}
              text-${question?.textAlign ?? "left"}
            `}
            dangerouslySetInnerHTML={{ __html: question.value }}
          />
        )}
        
        {image && !hasLinkedImages && (
          <div className="quiz-image">
            <img src={image} alt="" />
          </div>
        )}
        <div className={`question-answer-wrapper ${columnDirection ? 'column-direction' : '' }`}>
          {hasLinkedImages && (
            <div className="quiz-images-grid">
              {images.map((img, index) => (
                <div 
                  key={index} 
                  className={`quiz-image-item ${getImageState(index)}`}
                >
                  <img src={img.src} alt="" />
                </div>
              ))}
            </div>
          )}
          
          <div className="quiz-options">
            {options.map((option, index) => {
              const isSelected = selectedOption?.index === index;

              let stateClass = '';
              if (isChecked && isSelected) {
                stateClass = option.correct ? 'correct' : 'incorrect';
              } else if (isSelected) {
                stateClass = 'selected';
              }

              return (
                <button
                  key={index}
                  onClick={() => handleSelect(option, index)}
                  className={`quiz-option ${stateClass}`}
                  dangerouslySetInnerHTML={{ __html: option.text }}
                >
                </button>
              );
            })}
          </div>
        </div>

        {showFeedback && (
          <div
            className={`quiz-feedback ${feedbackClass}`}
            dangerouslySetInnerHTML={{ __html: feedbackContent }}
          />
        )}

      </div>
    </div>
  );
}
